<script setup lang="ts">
import DdtSpinner from './DdtSpinner.vue';

withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
    size?: 'md' | 'sm';
    type?: 'button' | 'submit' | 'reset';
    loading?: boolean;
    disabled?: boolean;
  }>(),
  { variant: 'primary', size: 'md', type: 'button', loading: false, disabled: false },
);
</script>

<template>
  <button
    :type="type"
    class="ddt-button"
    :class="[`ddt-button--${variant}`, { 'ddt-button--sm': size === 'sm' }]"
    :disabled="disabled || loading"
    :aria-busy="loading || undefined"
  >
    <DdtSpinner v-if="loading" aria-hidden="true" />
    <slot />
  </button>
</template>
